import { combineReducersWithFullState } from '../utils/redux';
import currentPage from './currentPage'
import selectedStompunkter from './selectedStompunkter'
import heavyStompunkter from './heavyStompunkter'
import lightStompunkter from './lightStompunkter'
import currentStompunkt from './currentStompunkt'
import layout from './layout'
import filter from './filter'
import mapBounds from './mapBounds'
import mapView from './mapView'
import seenViews from './seenViews'
import search from './search'
import basemap from './basemap'
import pendingRequestCount from './pendingRequestCount'
import latestLoadLightError from './latestLoadLightError'
import showPermalink from './showPermalink'
import selectWithPolygon from './selectWithPolygon'
import exportSettings from './exportSettings'
import isExporting from './isExporting'
import srid from './srid'
import selectionPagination from './selectionPagination'
import legalDialog from './legalDialog'
import showLabels from './showLabels'

export default combineReducersWithFullState({
   currentPage,
   selectedStompunkter,
   heavyStompunkter,
   lightStompunkter,
   currentStompunkt,
   layout,
   filter,
   mapBounds,
   mapView,
   seenViews,
   search,
   basemap,
   pendingRequestCount,
   latestLoadLightError,
   showPermalink,
   selectWithPolygon,
   exportSettings,
   isExporting,
   srid,
   selectionPagination,
   legalDialog,
   showLabels
})



// WEBPACK FOOTER //
// ./src/reducers/index.js